import { useParams } from 'react-router-dom';

import { useApiQuery } from 'shared/hooks/useApiQuery';

const useIntegrationSellerReqsPage = () => {
  const { sellerId } = useParams();

  const { data: markdown = null, isLoading: loading } = useApiQuery(
    ['integrationDetailsMarkdown'],
    () =>
      fetch('/IntegrationDetails.md').then((res) => {
        if (!res.ok) throw new Error('Failed to load integration details');
        return res.text();
      }),
    {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000,
    },
  );

  return {
    sellerId,
    markdown,
    loading,
  };
};

export default useIntegrationSellerReqsPage;
